import { Field, Form, Formik } from 'formik'
import { Button, Grid } from '@material-ui/core'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../components/api'

export const Cadastro = ({ objeto, voltar }) => {
  const initialValues = {
    userOrigem: objeto?.userOrigem?.[1] || undefined,
    userDestino: objeto?.userDestino?.[1] || undefined,
    dsTipoDenuncia: objeto?.dsTipoDenuncia || undefined,
    dtDenuncia: objeto?.dtDenuncia || undefined,
    snBloquear: objeto?.snBloquear || false,
    snRestringir: objeto?.snRestringir || false,
    dtRevisao: objeto?.dtRevisao || undefined,
    dsAcao: objeto?.dsAcao || undefined,
  }

  const salva = async (values) => {

    const dados = {
      idDenuncia: objeto.idDenuncia,
      dsAcao: values.dsAcao
    }
    const res = await metodoPrograma('salva', dados)
    if (res.status) voltar()
  }
  
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, setFieldValue, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Field
                component={TextField}
                InputLabelProps={{ shrink: true }}
                name="userOrigem"
                label="Reporting user"
                disabled={true}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                component={TextField}
                InputLabelProps={{ shrink: true }}
                name="userDestino"
                label="Restrict user"
                disabled={true}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                component={TextField}
                InputLabelProps={{ shrink: true }}
                name="dtDenuncia"
                label="Report Date"
                disabled={true}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                component={TextField}
                InputLabelProps={{ shrink: true }}
                name="dsTipoDenuncia"
                label="Type"
                disabled={true}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                component={TextField}
                InputLabelProps={{ shrink: true }}
                name="snBloquear"
                label="Block user"
                disabled={true}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                component={TextField}
                InputLabelProps={{ shrink: true }}
                name="snRestringir"
                label="Restrict user"
                disabled={true}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                InputLabelProps={{ shrink: true }}
                name="dsAcao"
                label="Report Review Actions"
                fullWidth
                margin="dense"
                variant="outlined"
                multiline
                rows={4}
              />
            </Grid>
            { objeto?.dtRevisao && 
              <Grid item xs={12}>
                <Grid container justifyContent="flex-end">
                  <Grid item xs={2}>
                    <Field
                      component={TextField}
                      InputLabelProps={{ shrink: true }}
                      name="dtRevisao"
                      label="Report Review Date"
                      disabled={true}
                      fullWidth
                      margin="dense"
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Grid>
            }         
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Save
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
